require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./crisis-outreach-response-team.json") })
        }
      }, "path---crisis-outreach-response-team");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---crisis-outreach-response-team!./.cache/json/crisis-outreach-response-team.json
// module id = 868
// module chunks = 231608221292675